const debug = false
// const debug = "editFormAction"

export default function editFormAction(id: ID) {
    debug && console.log(debug, 'open', id)
    gd.goTo('edit-form/{0}'.f(id))
}